import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    height: fit-content;
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;
    padding: 24px;

    .title-service {
        font-size: 36px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.interfaceTextGray};
    }

    .countie-process {
        display: grid;
        grid-template-columns: 327px 1fr;
        
        .title-infos {
            display: flex;
            flex-direction: column;
            align-self: flex-start;
            gap: 8px;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            font-weight: 400;

            span {
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
            }

            .info {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px;
                border-radius: 8px;
                background: ${({ theme }) => theme.colors.background};
                width: fit-content;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
                font-weight: 400;
                text-transform: capitalize;
            }
        }
    }
    @media (max-width: 768px) {
        .countie-process {
            grid-template-columns: 1fr;
            gap: 12px;
        }
        .title-service {
            font-size: 28px;
        }
    }

    .address {
        display: flex;
        flex-direction: column;
        gap: 8px;

        span {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
        }

        .address-info {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .info {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px;
                border-radius: 8px;
                background: ${({ theme }) => theme.colors.background};
                width: fit-content;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
                font-weight: 400;
            }
        }

    }

    .virtual-address {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: fit-content;   

        .title-infos {
            display: flex;
            flex-direction: column;
            align-self: flex-start;
            gap: 8px;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            font-weight: 400;
            width: 100%;

            span {
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.interfaceGray400};
            }

            .info {
                height: fit-content;
                word-wrap: break-word;
                padding: 8px;
                border-radius: 8px;
                background: ${({ theme }) => theme.colors.background};
                color: ${({ theme }) => theme.colors.interfaceTextGray};
                font-weight: 400;                
            }
        }    
    }

    .line {
        display: flex;
        gap: 16px;

        .label-state {
            width: 100%;
            p {
                margin-bottom: 8px;
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
            }  
            .error {
                position: absolute;
                display: block;
                top: 5%;
                right: 5%;
                color: ${({ theme }) => theme.colors.interfaceDanger};
            }

            .no-data {
                margin-top: 20px;
                font-weight: 400;
                color: ${({ theme }) => theme.colors.interfaceTextGray};
            }

            .css-319lph-ValueContainer {
                text-transform: capitalize;
            }
        }

        .small {
            width: 312px;
            &.highlight {
                input {
                    border: 1px solid ${({ theme }) => theme.colors.secondaryPool500};
                }
            }
        }

        .mid {
            width: 100%;
            &.highlight {
                input {
                    border: 1px solid ${({ theme }) => theme.colors.secondaryPool500};
                }
            }
        }

        .big {
            width: 100%;
        }

        .date {
            width: 100%;
            height: 48px;

            .react-datetime-picker {
                width: 100%;
                height: 48px;
                display: inline-flex;
                position: relative;
            }
            .react-datetime-picker,
            .react-datetime-picker *,
            .react-datetime-picker *:before,
            .react-datetime-picker *:after {
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
            }
            .react-datetime-picker--disabled {
                background-color: ${(props: any) => props.theme.colors.cf0f0f0};
                color: ${(props: any) => props.theme.colors.c6d6d6d};
            }
            .react-datetime-picker__wrapper {
                display: flex;
                flex-grow: 1;
                flex-shrink: 0;
                border: thin solid ${(props: any) => props.theme.colors.interfaceText100};
                border-radius: 8px;
                padding: 8px 16px;

            }
            .react-datetime-picker__inputGroup {
                min-width: calc(4px + (4px * 3) +  0.54em * 6  +  0.217em * 2);
                flex-grow: 1;
                padding: 0 2px;
            }
            .react-datetime-picker__inputGroup__divider {
                padding: 8px 0;
                white-space: pre;
                &:nth-child(7) {
                    padding: 8px;
                    &::before {
                        content: '|';
                    }
                }
            }
            .react-datetime-picker__inputGroup__input {
                min-width: 0.54em;
                height: calc(100% - 3px);
                position: relative;
                padding: 1px;
                border: 0;
                background: none;
                font: inherit;
                font-size: 16px;
                font-weight: 400;
                color: ${({ theme }) => theme.colors.interfaceText500};
                box-sizing: content-box;
                -moz-appearance: textfield;
            }
            .react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,
            .react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            .react-datetime-picker__inputGroup__input:invalid {
                background: rgba(255, 0, 0, 0.1);
            }
            .react-datetime-picker__inputGroup__input--hasLeadingZero {
                margin-left: -0.54em;
                padding-left: calc(1px +  0.54em);
            }
            .react-datetime-picker__inputGroup__amPm {
                font: inherit;
                -moz-appearance: menulist;
            }
            .react-datetime-picker__button {
                border: 0;
                background: transparent;
                padding: 4px 6px;
            }
            .react-datetime-picker__button:enabled {
                cursor: pointer;
            }
            .react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon,
            .react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon {
                stroke: ${(props: any) => props.theme.colors.c0078d7};
            }
            .react-datetime-picker__button:disabled .react-datetime-picker__button__icon {
                stroke: ${(props: any) => props.theme.colors.c6d6d6d};
            }
            .react-datetime-picker__button svg {
                display: inherit;
            }
            .react-datetime-picker__calendar,
            .react-datetime-picker__clock {
                position: absolute;
                top: 100%;
                left: 0;
                z-index: 1;
            }
            .react-datetime-picker__calendar--closed,
            .react-datetime-picker__clock--closed {
                display: none;
            }
            .react-datetime-picker__calendar {
                width: 350px;
                max-width: 100vw;
            }
            .react-datetime-picker__calendar .react-calendar {
                border-width: thin;
            }
            .react-datetime-picker__clock {
                width: 200px;
                height: 200px;
                max-width: 100vw;
                padding: 25px;
                background-color: ${(props: any) => props.theme.colors.interfacePure0};
                border: thin solid ${(props: any) => props.theme.colors.ca0a096};
            }                        
        }
    }
`
